// API helpers for Cancellation Rules & role-guarded cancellation approval
// (G13). Tenant headers are sent explicitly on every call — see
// ipdEnhancementsApi.js.

import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders(extra = {}) {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
    ...extra,
  };
}

export async function getCancellationRules() {
  const res = await axios.get(`${BASE}cancellation_rules/`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}

// role is unique — this is an upsert: send an existing role to update it.
export async function saveCancellationRule({
  role,
  canCancelWithinHours,
  requiresSupervisorApproval,
  allowedReasonIds,
  isActive,
}) {
  const body = { role };
  if (canCancelWithinHours !== undefined) body.can_cancel_within_hours = canCancelWithinHours;
  if (requiresSupervisorApproval !== undefined) body.requires_supervisor_approval = requiresSupervisorApproval;
  if (allowedReasonIds !== undefined) body.allowed_reason_ids = allowedReasonIds;
  if (isActive !== undefined) body.is_active = isActive;
  const res = await axios.post(`${BASE}cancellation_rules/`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res?.data;
}

export async function updateCancellationRule(id, fields) {
  const body = {};
  if (fields.role !== undefined) body.role = fields.role;
  if (fields.canCancelWithinHours !== undefined) body.can_cancel_within_hours = fields.canCancelWithinHours;
  if (fields.requiresSupervisorApproval !== undefined) body.requires_supervisor_approval = fields.requiresSupervisorApproval;
  if (fields.allowedReasonIds !== undefined) body.allowed_reason_ids = fields.allowedReasonIds;
  if (fields.isActive !== undefined) body.is_active = fields.isActive;
  const res = await axios.put(`${BASE}cancellation_rules/${id}/`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res?.data;
}

export async function getCancellationApprovals({ status, admissionId } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (admissionId) params.set("admission_id", admissionId);
  const qs = params.toString();
  const res = await axios.get(
    `${BASE}cancellation_approval/${qs ? `?${qs}` : ""}`,
    { headers: authHeaders() }
  );
  return res?.data?.data || [];
}

export async function approveCancellationApproval(id) {
  const res = await axios.put(
    `${BASE}cancellation_approval/${id}/approve/`,
    {},
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}

export async function rejectCancellationApproval(id, notes) {
  const body = {};
  if (notes) body.notes = notes;
  const res = await axios.put(
    `${BASE}cancellation_approval/${id}/reject/`,
    body,
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}
